export default __webpack_public_path__ + "static/media/hht2_ep_03.acb7d1d5.png";